import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const CustomBarChart = ({ data, xAxisDataKey, bars, legendRenderCallback }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          bottom: 5,
          left: 20,
          right: 30,
          top: 20,
        }}
      >
        <CartesianGrid horizontal={true} vertical={false} stroke="#f5f5f5" />
        <XAxis axisLine={false} dataKey={xAxisDataKey} tick={{ fill: "#313A3D", fontSize: 12 }} />
        <YAxis axisLine={false} tick={{ fill: "#313A3D", fontSize: 12 }} />
        <Tooltip />
        <Legend content={legendRenderCallback} />
        {bars &&
          bars.length &&
          bars.map((e, index) => (
            <Bar
              key={`bar_${index}`}
              name={e.label || null}
              dataKey={e.name}
              barSize={26}
              fill={e.color}
            />
          ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
